<template>
    <div>
        <PullRefresh v-model="isReFresh" @refresh="onRefresh">
            <List
                    style="height: 100%;margin-top:-5px;padding: 5px 12px"
                    v-model="loading"
                    :finished="finished"
                    finished-text="没有更多了"
                    loading-text="拼命加载中..."
                    @load="onLoad"
                    :offset="50"
                    :immediate-check="true"
            >
                <TaskSafeItem v-for="(item) in taskSafes" :key="item.id" :taskSafe="item"/>
            </List>
        </PullRefresh>
    </div>
</template>

<script>
    import {Button, List, PullRefresh, Search} from "vant"
    import TaskSafeItem from "./components/TaskSafeItem";
    import {formatSearchData} from "@/utils/format";

    export default {
        components: {
            TaskSafeItem, Search, PullRefresh, List, Button,
        },
        props: ['positionId', 'unitId'],

        data() {
            return {
                first: true,
                taskSafes: [],
                isReFresh: false,
                loading: false,
                finished: false,
            }
        },
        computed: {},
        created() {
        },
        mounted() {
        },
        methods: {
            onRefresh() {
                this.isReFresh = true;
                this.taskSafes = [];
                this.onLoad(true);
            },
            onLoad(isPullRefresh) {
                const data = {
                    unitId: this.unitId,
                    positionId: this.positionId,
                    currentUnit: true,
                    state: 'UN_FINISH',
                    size: 20,
                    page: this.taskSafes.length / 20 + 1
                }
                formatSearchData(data);
                this.$http.tokiot.safety.task.list(data).then(res => {
                    if (res) {
                        const list = res.rows
                        if (this.first) {
                            this.first = false
                            if (list.length == 0) {
                                this.$toast.fail('当前打卡点，不存在匹配的打卡任务')
                                setTimeout(()=>this.$router.replace('/'),1500)
                            } else if (list.length == 1) {
                                this.$router.replace(`/safety/task/${list[0].state}/${list[0].id}/${this.positionId}`)
                            }

                        }
                        this.taskSafes.push(...list);
                        this.loading = false;
                        if (isPullRefresh) this.isReFresh = false;
                        if (this.taskSafes.length >= res.total) {
                            this.finished = true;
                        }
                    }
                })
            },
        },
        watch: {}
    }
</script>

<style lang="less" scoped>
    .fixed-bottom-button {
        position: fixed;
        margin-left: 8px;
        bottom: 51px;
        width: calc(100% - 16px);
    }
</style>